import React from 'react';
import { MicroserviceTypes } from 'typings';
import { CommonDeleteModal } from 'components';
import { useDeleteModal } from './useDeleteModal';

interface DeleteModal {
  openModal: boolean;
  dataToDelete: Record<string, any> | undefined;
  onDeleteModalClose: () => void;
  entityName: string;
  service?: MicroserviceTypes;
}

export const DeleteModal = (props: DeleteModal) => {
  const { openModal, onDeleteModalClose, dataToDelete, service, entityName } = props;
  const { onRemoveConfirm, contextHolder, isLoading } = useDeleteModal(onDeleteModalClose, entityName, service);
  return (
    <>
      {contextHolder}
      <CommonDeleteModal
        onCancel={onDeleteModalClose}
        open={openModal}
        isLoading={isLoading}
        onOk={() => onRemoveConfirm(dataToDelete)}
        onClose={onDeleteModalClose}
        title={'Delete Attachment'}
        message={'Are you sure you want to delete this attachment?'}
      />
    </>
  );
};
